module.exports = __webpack_public_path__ + "static/media/no-result-found.3e0b26d5.png";